import { TemplateChannel, TemplateContext, type TemplatePair } from '@fluenceur/types';
import type { EmailComposerMode } from '@/hooks/use-email-composer-mode';

/**
 * Map an email composer send mode to the (channel, context) template pair.
 *
 * Every composer sends over email. An invitation follow-up, single or grouped,
 * binds the `email/invitation` library; every other message, a plain email to
 * an invitation included, binds `email/generic`.
 */
export const emailComposerModeToPair = (mode: EmailComposerMode): TemplatePair => {
  if (
    (mode.type === 'invitation-outreach' || mode.type === 'invitation-outreach-bulk') &&
    mode.kind === 'follow_up'
  ) {
    return { channel: TemplateChannel.EMAIL, context: TemplateContext.INVITATION };
  }
  return { channel: TemplateChannel.EMAIL, context: TemplateContext.GENERIC };
};
